import React from "react";
import { LinkButton } from "../components";

export const Pager = ({ pageContext }) => {
  const { previousPagePath, nextPagePath } = pageContext;
  return (
    <nav className="w-full bg-white px-4 py-3 flex items-center sm:px-6 mx-auto">
      <div className="flex max-w-xl items-center mx-auto mt-4 space-x-4">
        <LinkButton
          shadow
          disabled={previousPagePath === ""}
          size="large"
          to={previousPagePath !== "" ? previousPagePath : null}
        >
          Anterior
        </LinkButton>
        <LinkButton
          shadow
          disabled={nextPagePath === ""}
          size="large"
          to={nextPagePath !== "" ? nextPagePath : null}
        >
          Siguiente
        </LinkButton>
      </div>
    </nav>
  );
};
